import { type InsuranceCorporateIdentity } from "../types";

export function KnappschaftLogo({ className }: { className?: string }) {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M170.284 257C170.284 209.077 209.2 170.194 257.164 170.194C305.127 170.194 344.044 209.077 344.044 257C344.044 304.923 305.127 343.806 257.164 343.806C209.2 343.806 170.284 305.032 170.284 257ZM448.147 286.19C434.085 378.986 353.963 450 257.164 450C225.878 450 196.337 442.594 170.284 429.415V340.757C192.194 363.52 223.044 377.679 257.164 377.679C279.183 377.679 299.786 371.798 317.554 361.56L448.147 286.19ZM186.962 77.1789C208.764 68.6834 232.419 64 257.164 64C360.177 64 444.332 144.489 450 245.999L373.258 290.328C376.31 279.764 377.945 268.545 377.945 257C377.945 212.344 353.745 173.352 317.663 152.549L186.962 77.1789ZM64 257C64 189.472 98.6648 130.112 151.207 95.5858L228.058 139.915C175.407 152.876 136.491 200.363 136.491 257V407.631C92.3423 372.343 64 317.993 64 257Z"
        fill="white"
      />
    </svg>
  );
}

export const Knappschaft: InsuranceCorporateIdentity = {
  id: "knappschaft",
  name: "Knappschaft",
  logo: KnappschaftLogo,
  backgroundColor: "#AE130F",
  textColor: "#FFFFFF",
  wildcard: "knappschaft",
  type: "statutory",
};
